import type { SourceAndLayerConfigs } from "@/models";

const accessibilityResultConfig: SourceAndLayerConfigs = {
  layerConfigs: [
    {
      id: "accessibility",
      type: "fill-extrusion",
      source: "accessibility",
      paint: {
        "fill-extrusion-height": 0.2,
        "fill-extrusion-base": 0.25,
        "fill-extrusion-opacity": 0.8,
        // "fill-extrusion-color": [
        //   "interpolate",
        //   ["linear"],
        //   ["get", "value"],
        //   0,
        //   "#000080",
        //   0.25,
        //   "#0000FF",
        //   0.5,
        //   "#00FF00",
        //   0.75,
        //   "#FFFF00",
        //   1,
        //   "#FF0000",
        // ],
        // Alternative: Viridis palette (commented out)
        "fill-extrusion-color": [
          "interpolate",
          ["linear"],
          ["get", "value"],
          0,
          "#440154",
          0.25,
          "#3B528B",
          0.5,
          "#21918C",
          0.75,
          "#5EC962",
          1,
          "#FDE725",
        ],
        // Alternative: Turbo palette (commented out)
        // "fill-extrusion-color": [
        //   "interpolate",
        //   ["linear"],
        //   ["get", "value"],
        //   0,
        //   "#30123B",
        //   0.25,
        //   "#2F6B8E",
        //   0.5,
        //   "#1FC980",
        //   0.75,
        //   "#FDE725",
        //   1,
        //   "#E71D36",
        // ],
      },
    },
  ],
  source: {
    id: "accessibility",
    options: {
      type: "geojson",
      data: {},
    },
  },
};

export default accessibilityResultConfig;

